// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {FetchPaymentSuccess} from 'redux/v1/paymentTravel/selectedPayment/actions';
import type {SelectedPaymentState} from 'redux/v1/paymentTravel/selectedPayment/SelectedPaymentState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {PUT_PAYMENT_CC} from 'redux/v1/paymentTravel/cc/actions';
import {DELETE_PAYMENT} from 'redux/v1/paymentTravel/delete/actions';
import {PUT_PAYMENT_INVOICE} from 'redux/v1/paymentTravel/invoice/actions';
import {selectedPaymentState} from 'redux/v1/paymentTravel/PaymentTravelState';
import {PUT_PAYMENT_PAYPAL} from 'redux/v1/paymentTravel/paypal/actions';
import {FETCH_PAYMENT} from 'redux/v1/paymentTravel/selectedPayment/actions';
import {PUT_PAYMENT_SEPA} from 'redux/v1/paymentTravel/sepa/put/actions';

export const initialState: SelectedPaymentState = {
  loading: false,
};

const actionCreators: ActionHandlers<SelectedPaymentState> = {
  [PENDING(FETCH_PAYMENT)]: (state: SelectedPaymentState) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(FETCH_PAYMENT)]: (
    state: SelectedPaymentState,
    action: FetchPaymentSuccess
  ) => ({
    ...state,
    loading: false,
    selectedPayment: action.data.code,
  }),
  [ERROR(FETCH_PAYMENT)]: (state: SelectedPaymentState, action: any) => ({
    ...state,
    loading: false,
    error: action.error,
  }),
  [SUCCESS(DELETE_PAYMENT)]: (state: SelectedPaymentState) => ({
    ...state,
    selectedPayment: '',
  }),
  [SUCCESS(PUT_PAYMENT_SEPA)]: (state: SelectedPaymentState) => ({
    ...state,
    selectedPayment: 'SEPA',
  }),
  [SUCCESS(PUT_PAYMENT_INVOICE)]: (state: SelectedPaymentState) => ({
    ...state,
    selectedPayment: 'INVOICE',
  }),
  [SUCCESS(PUT_PAYMENT_CC)]: (state: SelectedPaymentState) => ({
    ...state,
    selectedPayment: 'cc',
  }),
  [SUCCESS(PUT_PAYMENT_PAYPAL)]: (state: SelectedPaymentState) => ({
    ...state,
    selectedPayment: 'PAYPAL',
  }),
};

export const selectedPaymentReducer: Reducer<SelectedPaymentState> =
  // $FlowFixMe
  createReducerUsingActionHandlers<SelectedPaymentState>(
    initialState,
    actionCreators
  );

export const isLoaded: Selector<boolean> = createSelector(
  selectedPaymentState,
  (state: SelectedPaymentState) =>
    !state.loading && state.selectedPayment !== undefined
);

export const hasError: Selector<boolean> = createSelector(
  selectedPaymentState,
  (state: SelectedPaymentState) => !state.loading && state.error !== undefined
);

export const getSelectedPayment: Selector<string> = createSelector(
  selectedPaymentState,
  (state: SelectedPaymentState) => state.selectedPayment || ''
);
